import { Observable } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { ListObject, LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';

export interface FailedMessagesListFacadeInterface<FailedMessageModel> extends LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean>;
  listDto$: Observable<ListObject<FailedMessageModel>>;
  items$: Observable<FailedMessageModel[]>;
  totalElements$: Observable<number>;
}

export interface FailedTransactionMessageFacadeInterface extends SetInitialStateFacade {
  failedTransactionMessage$: Observable<string>;
  loaded$: Observable<boolean>;
  loadFailedTransactionMessage(rawMessageId: string): void;
}

export interface FailedMessagesExportFacadeInterface extends SetInitialStateFacade {
  startExportToFile(reportName: string, dialogRef: MatDialogRef<unknown>, navigationNeeded: boolean): void;
}
